import { useEffect, useRef, useCallback, useMemo, LegacyRef, useState } from "react";
import TreeView from "devextreme-react/tree-view";
import { navigation } from "../../app-navigation";
import { useNavigation } from "../../contexts/navigation";
import "./side-navigation-menu.scss";

import * as events from "devextreme/events";
import { useSelector } from "react-redux";
import { getLocalizedMenu } from "../../redux/localization";
import ScrollView from "devextreme-react/scroll-view";

const SideNavigationMenu = (props: any) => {
  const strings = useSelector(getLocalizedMenu);
  const { children, selectedItemChanged, openMenu, compactMode, onMenuReady } =
    props;

  function normalizePath() {
    return navigation(strings).map((item) => {
      if (item.path && !/^\//.test(item.path)) {
        item.path = `/${item.path}`;
      }
      return { ...item, expanded: false };
    });
  }

  const items = useMemo(
    normalizePath,
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  const {
    navigationData: { currentPath },
  } = useNavigation();

  const treeViewRef = useRef() as LegacyRef<TreeView> | undefined;
  const wrapperRef = useRef();
  const getWrapperRef = useCallback(
    (element) => {
      const prevElement = wrapperRef.current;
      if (prevElement) {
        events.off(prevElement, "dxclick");
      }

      wrapperRef.current = element;
      events.on(element, "dxclick", (e: any) => {
        openMenu(e);
      });
    },
    [openMenu]
  );

  useEffect(() => {
    //@ts-ignore
    const treeView = treeViewRef.current && treeViewRef.current.instance;
    if (!treeView) {
      return;
    }

    if (currentPath !== undefined) {
      treeView.selectItem(currentPath);
      treeView.expandItem(currentPath);
    }

    if (compactMode) {
      treeView.collapseAll();
    }
  }, [currentPath, compactMode]);

  const [scrollDatas] = useState({
    showScrollBarMode: 'onScroll',
    pullDown: false,
    scrollByContent: true,
    scrollByThumb: true,
  });
  return (
    <div
      className={"dx-swatch-additional side-navigation-menu"}
      ref={getWrapperRef}
    >
      {children}
      <ScrollView 
        scrollByContent={scrollDatas.scrollByContent}
        bounceEnabled={scrollDatas.pullDown}
        showScrollbar={"onScroll"}
        scrollByThumb={scrollDatas.scrollByThumb}>
        <div className={"menu-container"}>
          <TreeView
            ref={treeViewRef}
            items={items}
            keyExpr={"path"}
            selectionMode={"single"}
            focusStateEnabled={false}
            expandEvent={"click"}
            onItemClick={selectedItemChanged}
            onContentReady={onMenuReady}
            width={"100%"}
            onItemExpanded={(e) => {
              console.log("collapse", e.node);
              var nodes = e.component.getNodes();
              var filtered = nodes.filter((x) => x.key !== e.node?.key);

              filtered?.forEach((item) => {
                e.component.collapseItem(item.key);
              });
            }}
          />
        </div>
      </ScrollView>
    </div>
  );
};

export default SideNavigationMenu;
